import Select from "react-select";
import { useTranslation } from "react-i18next";
import { StockCorrectionData } from "../../models/StockData";

interface HiddenStockDropdownProps {
  selectedItem: string;
  handleItemChange: (selectedItemId: string | undefined) => void;
  hiddenItems: StockCorrectionData[];
}

const HiddenStockDropdown: React.FC<HiddenStockDropdownProps> = ({
  selectedItem,
  handleItemChange,
  hiddenItems,
}) => {
  const { t } = useTranslation();

  const stockOptions = hiddenItems.map((item) => ({
    value: item.id,
    label: item.blocked
      ? `${item.no} - ${item.description} - ${t("correction.blocked")}`
      : `${item.no} - ${item.description}`,
    isDisabled: item.blocked,
  }));

  const handleSelectChange = (selectedOption: any) => {
    handleItemChange(selectedOption?.value);
  };

  stockOptions.unshift({ value: "", label: t("correction.select_item"), isDisabled: false });

  return (
    <Select
      value={stockOptions.find((option) => option.value === selectedItem)}
      onChange={handleSelectChange}
      options={stockOptions}
      placeholder={t("correction.select_item")}
      isClearable
      menuPlacement="top"
    />
  );
};

export default HiddenStockDropdown;
